"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addAddressEvmOperation = void 0;
var common_core_1 = require("@moralisweb3/common-core");
var common_evm_utils_1 = require("@moralisweb3/common-evm-utils");
exports.addAddressEvmOperation = {
    method: 'POST',
    name: 'addAddressEvm',
    id: 'AddAddressToStream',
    groupName: 'evmStreams',
    urlPathPattern: '/streams/evm/{id}/address',
    bodyParamNames: ['address'],
    urlPathParamNames: ['id'],
    bodyType: 'properties',
    getRequestUrlParams: getRequestUrlParams,
    getRequestBody: getRequestBody,
    deserializeResponse: deserializeResponse,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
};
// Methods
function getRequestUrlParams(request) {
    return {
        id: request.id,
    };
}
function getRequestBody(request, core) {
    return {
        address: Array.isArray(request.address)
            ? request.address.map(function (a) { return common_evm_utils_1.EvmAddress.create(a, core).checksum; })
            : common_evm_utils_1.EvmAddress.create(request.address, core).checksum,
    };
}
function deserializeResponse(jsonResponse) {
    var data = (0, common_core_1.toCamelCase)(jsonResponse);
    return __assign(__assign({}, data), { address: data.address
            ? typeof data.address === 'string'
                ? common_evm_utils_1.EvmAddress.create(data.address)
                : data.address.map(function (address) { return common_evm_utils_1.EvmAddress.create(address); })
            : undefined });
}
function serializeRequest(request, core) {
    return {
        id: request.id,
        address: Array.isArray(request.address)
            ? request.address.map(function (a) { return common_evm_utils_1.EvmAddress.create(a, core).checksum; })
            : common_evm_utils_1.EvmAddress.create(request.address, core).checksum,
    };
}
function deserializeRequest(jsonRequest, core) {
    return {
        id: jsonRequest.id,
        address: Array.isArray(jsonRequest.address)
            ? jsonRequest.address.map(function (a) { return common_evm_utils_1.EvmAddress.create(a, core); })
            : common_evm_utils_1.EvmAddress.create(jsonRequest.address, core),
    };
}
//# sourceMappingURL=addAddressEvmOperation.js.map